import { render } from "./categoriesComponent.vue?vue&type=template&id=6b89333a&scoped=true"
import script from "./categoriesComponent.vue?vue&type=script&lang=js"
export * from "./categoriesComponent.vue?vue&type=script&lang=js"

import "./categoriesComponent.vue?vue&type=style&index=0&id=6b89333a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b89333a"]])

export default __exports__